type RequiredLookups = {
  contractorsList?: unknown[];
  equipmentTypeList?: unknown[];
  ticketStatusList?: unknown[];
  resourceTypeList?: unknown[];
  costRateTypeList?: unknown[];
  costRateUnitList?: unknown[];
  genericRelationsList?: unknown[];
  forestAreaList?: unknown[];
};

export function arePrerequisitesReady(lookups: RequiredLookups | null | undefined): boolean {
  if (!lookups) return false;

  return (
    Array.isArray(lookups.contractorsList) && lookups.contractorsList.length > 0 &&
    Array.isArray(lookups.equipmentTypeList) && lookups.equipmentTypeList.length > 0 &&
    Array.isArray(lookups.ticketStatusList) && lookups.ticketStatusList.length > 0 &&
    Array.isArray(lookups.resourceTypeList) && lookups.resourceTypeList.length > 0 &&
    Array.isArray(lookups.costRateTypeList) && lookups.costRateTypeList.length > 0 &&
    Array.isArray(lookups.costRateUnitList) && lookups.costRateUnitList.length > 0 &&
    Array.isArray(lookups.genericRelationsList) && lookups.genericRelationsList.length > 0 &&
    Array.isArray(lookups.forestAreaList) && lookups.forestAreaList.length > 0
  );
}
